export default __webpack_public_path__ + "static/media/regulatory--night-speed-limit-35--g1.3a039535.png";